import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";

export interface DataCacheConfig {
    filter?: any;
    paginator?: MatPaginator;
    sort?: MatSort;
    data?: any;
    cachedItems?: any[];
}

export enum CachedKeys {
    "ALL_CARTES" = "cachedCartes",
    "ALL_CHECKLISTS" = "cachedChecklists",
    "ALL_MODEL_CHECKLISTS" = "cachedChecklistModels",
    "ALL_OPERATIONS" = "cachedOperations",
    "ALL_RO_TYPES" = "cachedRoTypes",
    "ALL_USERS" = "cachedUsers",
    "ALL_SURVEYS" = "cachedSurveys",
    "ALL_RO_STATES" = "roStates",
    "ALL_BUDGET_STATES" = "budgetStates"
}